module.exports = __webpack_public_path__ + "static/media/CollaborateIllustration.071a951c.svg";